import { IEntityDataService } from "@pit/core-data";
import { IDtoDevice, IDtoMandator } from "@pit/frontend-model";
import { Observable } from "rxjs";

export interface IDtoDeviceEntityDataService extends IEntityDataService<IDtoDevice> {

    getDeviceByDeviceId$(deviceId: string): Observable<IDtoDevice>;
    getDeviceByDeviceIdAsync(deviceId: string): Promise<IDtoDevice>;

    getDevicesForMandatorByDepotNumber$(mandator: string, depotNumber: string, onlyWithShipments?: boolean): Observable<IDtoDevice[]>;
    getDevicesForMandatorByDepotNumberAsync(mandator: string, depotNumber: string, onlyWithShipments?: boolean): Promise<IDtoDevice[]>;

    logoutDevice$(deviceId: string): Observable<boolean>;
    logoutDeviceAsync(deviceId: string): Promise<boolean>;

    resetDevice$(deviceId: string): Observable<boolean>;
    resetDeviceAsync(deviceId: string): Promise<boolean>;

    releaseDevice$(deviceId: string, userName?: string): Observable<IDtoDevice>;
    releaseDeviceAsync(deviceId: string, userName?: string): Promise<IDtoDevice>;

    assignMandatorToDevice$(deviceId: string, mandatorId: number, userName?: string): Observable<IDtoDevice>;
    assignMandatorToDeviceAsync(deviceId: string, mandatorId: number, userName?: string): Promise<IDtoDevice>;

    getAllMandators$(): Observable<IDtoMandator[]>;
    getAllMandatorsAsync(): Promise<IDtoMandator[]>;

}
